/* eslint-disable */
import { useEffect, useState } from "react";
import api from "../api/PosApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DataTable from "react-data-table-component";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";

const MySwal = withReactContent(Swal);

export default function Anulaciones() {
    const [documentos, setDocumentos] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const cargarEmitidos = async () => {
        setLoading(true);
        try {
            const res = await api.get("/pos/ventas");
            const docs = res.data.filter(
                (d: any) =>
                    d.estadoMH === "ENVIADO" &&
                    d.tipoDte !== "05" &&
                    d.selloRecibido !== null
            );
            setDocumentos(docs);
        } catch {
            MySwal.fire("Error", "❌ Error cargando documentos", "error");
        } finally {
            setLoading(false);
        }
    };

    const anular = async (id: any) => {
        try {
            const confirm = await MySwal.fire({
                title: "¿Anular este documento?",
                text: "Esto lo marcará como anulado internamente y enviará la invalidación a Hacienda.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, invalidar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                reverseButtons: true,
            });

            if (!confirm.isConfirmed) return;

            const res = await api.post(`/pos/ventas/${id}/anular`);
            MySwal.fire({
                icon: "info",
                title: "Documento Anulado",
                text: `Estado: ${res.data.estado}`,
                timer: 2500,
                showConfirmButton: false,
            });
            cargarEmitidos();
        } catch {
            MySwal.fire("Error", "❌ Error al anular documento", "error");
        }
    };

    const notaCredito = async (id: any) => {
        try {
            const confirm = await MySwal.fire({
                title: "¿Emitir nota de crédito?",
                text: "Esto generará la nota de crédito y la enviará automáticamente a Hacienda.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, emitir",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                reverseButtons: true,
            });

            if (!confirm.isConfirmed) return;

            const res = await api.post(`/pos/ventas/${id}/nc`);
            MySwal.fire({
                icon: "info",
                title: "Nota de crédito emitida",
                text: `Estado: ${res.data.estado}`,
                timer: 2500,
                showConfirmButton: false,
            });
            cargarEmitidos();
        } catch {
            MySwal.fire("Error", "❌ Error al emitir nota de crédito", "error");
        }
    };

    useEffect(() => {
        cargarEmitidos();
    }, []);

    const columnas = [
        {
            name: "Fecha",
            selector: (row: any) => new Date(row.fechaEmision).toLocaleDateString(),
            sortable: true,
            width: "120px",
        },
        {
            name: "Cliente",
            selector: (row: any) => row.clienteNombre,
            sortable: true,
        },
        {
            name: "Tipo DTE",
            selector: (row: any) =>
                row.tipoDte === "01"
                    ? "Factura"
                    : row.tipoDte === "03"
                        ? "Crédito Fiscal"
                        : "",
        },
        {
            name: "Total",
            selector: (row: any) => `$${row.totalPagar.toFixed(2)}`,
            sortable: true,
            right: true,
        },
        {
            name: "Estado MH",
            selector: (row: any) => row.estadoMH,
            sortable: true,
        },
        {
            name: "Acciones",
            cell: (row: any) => (
                <div className="d-flex gap-2">
                    {row.tipoDte === "03" && (
                        <Button
                            size="sm"
                            variant="info"
                            onClick={() => notaCredito(row.id)}
                        >
                            Nota Crédito
                        </Button>
                    )}
                    {row.tipoDte === "01" && (
                        <Button size="sm" variant="danger" onClick={() => anular(row.id)}>
                            Anular
                        </Button>
                    )}
                </div>
            ),
        },
    ];

    const customStyles = {
        table: {
            style: { backgroundColor: "#121212" },
        },
        headCells: {
            style: {
                backgroundColor: "#1e1e1e",
                color: "#fff",
                fontWeight: "bold",
            },
        },
        rows: {
            style: {
                backgroundColor: "#181818",
                color: "#e0e0e0",
                "&:hover": { backgroundColor: "#222" },
                padding: "1rem"
            },
        },
        pagination: {
            style: {
                backgroundColor: "#121212",
                color: "#ccc",
            },
        },
    };

    return (
        <Container className="mt-4">
            <Row>
                <Col>
                    <Card className="card-black">
                        <Card.Header>
                            <h3 className="text-light">Anulaciones / Notas de Crédito</h3>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col>
                                    {loading ? (
                                        <div className="text-center text-light mt-5">
                                            <Spinner animation="border" variant="light" />
                                            <p className="mt-3">Cargando documentos...</p>
                                        </div>
                                    ) : (
                                        <DataTable
                                            columns={columnas}
                                            data={documentos}
                                            pagination
                                            highlightOnHover
                                            dense
                                            customStyles={customStyles}
                                            fixedHeader
                                            fixedHeaderScrollHeight="500px"
                                            noDataComponent="No hay documentos emitidos"
                                            paginationPerPage={8}
                                            paginationRowsPerPageOptions={[5, 8, 15, 25]}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



        </Container>
    );
}
